import React, { useState, useEffect } from 'react';
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import * as utils from './Utils.js'

const Login = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const auth = getAuth();
  const ADMIN_EMAIL = 'ccrane2@alumni.nd.edu';

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // Already logged in → redirect to admin
        navigate("/admin");
      }
    });
    return () => unsubscribe();
  }, [auth, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      await signInWithEmailAndPassword(auth, ADMIN_EMAIL, password);
      navigate("/admin");
    } catch (err) {
      console.error(err);
      setError("Incorrect password");
    }
  };

  return (
    <div className="Login">
      <div className='centered-box wedding-page-block'>
        <div className='wedding-centerpiece'>
          <p className='wedding-page-title'>Login</p>
          <div className="form-page-content">
            <div className="form-card">
              <div className="form-header">
                <p>Enter the admin password</p>
              </div>

              <form onSubmit={handleLogin}>
                <div className="form-field">
                  <label>Password</label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    required
                  />
                </div>

                {error && <p style={{ color: 'red', marginTop: '5px' }}>{error}</p>}

                <button type="submit" className="btn btn-navyblue">
                  Login
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className='centered-box'>
        { utils.displayCheckerboard(20, 42, ['blue', 'ivory']) }
      </div>
    </div>
  );
};

export default Login;
